import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { Icon } from '@picsio/ui';
import { BillInfo } from '@picsio/icons';

import Tooltip from '../../../Tooltip/Tooltip';
import styles from './ProductFieldLabel.module.scss';
import productInfoStyles from '../../styles.module.scss';

export default function ProductFieldLabel({ title, tooltip, isDiff }) {
  if (!tooltip && !isDiff) return title;

  return (
    <Tooltip content={isDiff ? 'Unpublished changes' : null} placement="top">
      <span className={cn(tooltip && styles.labelWithTooltip, isDiff && productInfoStyles.diffDot)}>
        {title}
        {tooltip && (
          <Tooltip content={tooltip} placement="top">
            <Icon size="xs">
              <BillInfo />
            </Icon>
          </Tooltip>
        )}
      </span>
    </Tooltip>
  );
}

ProductFieldLabel.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  isDiff: PropTypes.bool,
};

ProductFieldLabel.defaultProps = {
  tooltip: '',
  isDiff: false,
};
